import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { accountsClient } from 'src/utils/account';
import { PATHS } from 'src/constants/paths';
import { setToken } from 'src/reducers/user/userReducer';

const useRefreshSession = () => {
  const [isRefreshingSession, setIsRefreshingSession] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isRefreshingSession) {
      return;
    }

    (async () => {
      try {
        const tokens = await accountsClient.refreshSession();

        dispatch(setToken(tokens?.accessToken));
      } catch (e) {
        if (pathname !== PATHS.LOGIN) {
          navigate(PATHS.LOGIN);
        }
      }
      setIsRefreshingSession(false);
    })();
  }, [dispatch, isRefreshingSession, pathname, navigate]);

  return isRefreshingSession;
};

export default useRefreshSession;
